export class TreatGenModel {
    Seq: number
    intClinicNo: number

    constructor(
        Seq: number,
        intClinicNo: number
    ) {
        this.Seq = Seq
        this.intClinicNo = intClinicNo
    }
}
